import { Fragment } from "react";
import "./LatestBlog.scss";
import { motion } from "framer-motion";
import BlogCard from "../../../components/blogCard/BlogCard";

const LatestBlog = ({ classList, dataList }) => {
  return (
    <section className={`latest_blog ${classList}`}>
      <div className="content_wrap">
        <motion.p
          initial={{ translateY: 32, opacity: 0 }}
          whileInView={{ translateY: 0, opacity: 1 }}
          transition={{
            duration: 0.6,
            ease: "easeInOut",
          }}
          viewport={{ once: true }}
          className="t_20"
        >
          <span>_</span>Blog<span>_</span>
        </motion.p>
        <motion.h2
          initial={{ translateY: 32, opacity: 0 }}
          whileInView={{ translateY: 0, opacity: 1 }}
          transition={{
            duration: 0.6,
            ease: "easeInOut",
            delay: 0.15,
          }}
          viewport={{ once: true }}
          className="text-center"
        >
           News and Events
        </motion.h2>
        {dataList?.length > 0 ? (
          <div className="blog_grid">
            {dataList?.slice(0, 2)?.map((data) => {
              return (
                <Fragment key={data?._id}>
                  <BlogCard data={data} />
                </Fragment>
              );
            })}
          </div>
        ) : (
          <p className="text-center mt-4">Data not found...</p>
        )}
      </div>
    </section>
  );
};

export default LatestBlog;
